module.exports = __webpack_public_path__ + "img/canbadge_square_37mm_line.f3f4a74a.png";